import { ReactNode, useEffect } from "react";

import { useAuthStore } from "../stores/authStore";

/**
 * @deprecated Use useAuthStore directly from '@/stores/authStore'
 * This component is kept for backwards compatibility only.
 *
 * Example migration:
 * ```tsx
 * // OLD
 * const { user, login } = useAuth();
 *
 * // NEW (with useShallow for optimal performance)
 * import { useAuthStore } from '@/stores/authStore';
 * import { useShallow } from 'zustand/react/shallow';
 *
 * const { user, login } = useAuthStore(useShallow(state => ({
 *   user: state.user,
 *   login: state.login
 * })));
 * ```
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  const loadUser = useAuthStore((state) => state.loadUser);

  // Load user and permissions on mount (cookie sent automatically)
  useEffect(() => {
    loadUser();
  }, [loadUser]);

  return <>{children}</>;
}

/**
 * @deprecated Use useAuthStore directly
 * Legacy hook for backwards compatibility
 */
// eslint-disable-next-line react-refresh/only-export-components
export function useAuth() {
  return useAuthStore();
}
